import api from "utils/api";

// 내 강사 프로필 조회
export const getMyInstructorProfile = async () => {
  try {
      const res = await api.get(`/buccl_user/api/v1/instructor-profile/`);
      return res.data;
  } catch (error) {
      return null;
  }
};

// 프로필 공개 강사 목록 조회
export const getPublicInstructors = async () => {
  try {
      const res = await api.get(`/buccl_user/api/v1/instructors/`);
      return res.data;
  } catch (error) {
      return [];
  }
};

// 강사 공개 상세 조회
export const getInstructorDetail = async (userId) => {
  try {
      const res = await api.get(`/buccl_user/api/v1/instructors/${encodeURIComponent(userId)}/`);
      return res.data;
  } catch (error) {
      return null;
  }
};

// 강사 프로필 등록
export const createInstructorProfile = async (data) => {
  try {
      const res = await api.post(`/buccl_user/api/v1/instructor-profile/`, data);
      return res.data;
  } catch (error) {
      throw error;
  }
};

// 강사 프로필 수정 (변경된 필드만 전송)
export const patchInstructorProfile = async ( data) => {
  try {
      const res = await api.patch(`/buccl_user/api/v1/instructor-profile/`, data);
      return res.data;
  } catch (error) {
      throw error;
  }
};

// 강사 강습용 프로필 이미지 업로드 (ADR-017)
// 선결: InstructorProfile row 존재 필요 (404 INSTRUCTOR_PROFILE_NOT_FOUND 시 POST /instructor-profile/ 후 재시도)
export const uploadInstructorProfileImage = async (file) => {
    const formData = new FormData();
    formData.append("image", file);
    const res = await api.post(
        `/buccl_user/api/v1/instructor-profile-image/`,
        formData
    );
    return res.data;
};

// 강사 강습용 프로필 이미지 삭제
export const deleteInstructorProfileImage = async () => {
    const res = await api.delete(`/buccl_user/api/v1/instructor-profile-image/`);
    return res.data;
};

// 강사 프로필 다중 이미지 업로드 (BE issue #400 요청 스펙)
// 업로드만 담당 — 발급된 URL을 PATCH /instructor-profile/ 의
// main_slides / free_galleries 에 실어 저장한다.
// purpose: "main_slide" | "free_gallery" — 스토리지 경로·리사이즈 프리셋 구분용
// response: { image_urls: ["https://...", ...] }
export const uploadInstructorProfileImages = async (files, purpose) => {
    const formData = new FormData();
    files.forEach((file) => formData.append("images", file));
    if (purpose) formData.append("purpose", purpose);
    const res = await api.post(
        `/buccl_user/api/v1/instructor-profile-images/`,
        formData
    );
    return res.data;
};
